import React from "react";
import styles from "./HomeTestimonial.module.scss";
import { motion } from "framer-motion";
const { testimonial, textside, designside, activeTestimony } = styles;
const Testimonial = () => {
  return (
    <section className={`${testimonial} global-lr-pad`}>
      <motion.div
        className={textside}
        initial={{
          x: "-4rem",
          opacity: 0,
        }}
        whileInView={{
          x: 0,
          opacity: 1,
          transition: {
            duration: 0.7,
            type: "tween",
          },
        }}
      >
        <div>
          <span style={{ backgroundColor: "#710673" }}></span>
          <p>
            I'd fully recommend WeQuick Pay to anyone and everyone who loves a
            cashless system of making payments. The process is fast, efficient
            and secure. Yes, your data is safe with their QRcode too.
          </p>
        </div>
        <div className={activeTestimony}>
          <span style={{ backgroundColor: "#7B61FF" }}></span>
          <p>
            I'm highly in support of this app. The idea of seamless transactions
            done through QRcode is simply thrilling. Imagine the ease and speed
            you can use to send and receive money, you're looking at the future
            of payment right now.
          </p>
          <span>Gloria Rose</span>
        </div>
        <div>
          <span style={{ backgroundColor: "#0695FC" }}></span>
          <p>
            This is the best thing that can happen to Nigerians, and Africans at
            large. I particularly love the idea of skipping long queues at ATMs
            and going cashless.
          </p>
        </div>
        <div>
          <span style={{ backgroundColor: "#E32966" }}></span>
          <p>
            I love the fact that WeQuick Pay offers instant payment services
            amongst other things. I really, really like anything that saves me
            time, stress and money. An app that does this for me totally
            deserves my commendation.
          </p>
        </div>
      </motion.div>
      <motion.div
        className={designside}
        initial={{
          opacity: 0,
          scale: 0.5,
          rotate: 360,
        }}
        whileInView={{
          scale: 1,
          opacity: 1,
          rotate: 0,
          transition: {
            duration: 0.7,
            type: "tween",
            delay: 0.5,
          },
        }}
      >
        <h2>Testimonials</h2>
        <h1>Check what our clients are saying</h1>
        <button>Read More</button>
      </motion.div>
    </section>
  );
};

export default Testimonial;
